"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectInfoControls2 = exports.ObjectInfoControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class ObjectInfoControls {
    constructor(parentEl) {
        if (!parentEl)
            throw new Error("Parent element (objectInfo) is undefined");
        const title = this.createTitle();
        const element = this.createElement();
        this.element = new UiElements_1.DivEl()
            .addChild(title)
            .addChild(element);
        parentEl.appendChild(this.element.domEl);
    }
    dispose() {
        delete this.element;
    }
    createTitle() {
        const title = new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('objectInfoTitle')
            .addAttribute('data-i18n-key', 'OBJECT');
        return title;
    }
    createElement() {
        this.objectType = this.createTextDiv();
        this.objectUuid = this.createTextDiv();
        this.objectName = this.createInputDiv();
        this.objectName.setStyle({ 'width': '158px' });
        this.objectPositionX = this.createInputDiv();
        this.objectPositionY = this.createInputDiv();
        this.objectPositionZ = this.createInputDiv();
        this.objectRotationX = this.createInputDiv();
        this.objectRotationY = this.createInputDiv();
        this.objectRotationZ = this.createInputDiv();
        this.objectScaleX = this.createInputDiv();
        this.objectScaleY = this.createInputDiv();
        this.objectScaleZ = this.createInputDiv();
        this.objectIntensity = this.createInputDiv();
        this.objectColor = this.createColorDiv();
        this.objectDistance = this.createInputDiv();
        this.objectAngle = this.createInputDiv();
        this.objectPenumbra = this.createInputDiv();
        this.objectDecay = this.createInputDiv();
        this.objectUuidRow = this.createSingleRow(this.objectUuid);
        this.objectTypeRow = this.createKeyValRow(this.objectType, "TYPE");
        this.objectNameRow = this.createKeyValRow(this.objectName, "NAME");
        this.xyzLabelRow = this.createXYZLabelRow();
        this.objectPositionRow = this.createXYZRow(this.objectPositionX, this.objectPositionY, this.objectPositionZ, "POSITION");
        this.objectRotationRow = this.createXYZRow(this.objectRotationX, this.objectRotationY, this.objectRotationZ, "ROTATION");
        this.objectScaleRow = this.createXYZRow(this.objectScaleX, this.objectScaleY, this.objectScaleZ, "SCALE");
        this.objectIntensityRow = this.createKeyValRow(this.objectIntensity, "INTENSITY");
        this.objectColorRow = this.createKeyValRow(this.objectColor, "COLOR");
        this.objectDistanceRow = this.createKeyValRow(this.objectDistance, "DISTANCE");
        this.objectAngleRow = this.createKeyValRow(this.objectAngle, "ANGLE");
        this.objectPenumbraRow = this.createKeyValRow(this.objectPenumbra, "PENUMBRA");
        this.objectDecayRow = this.createKeyValRow(this.objectDecay, "DECAY");
        return new UiElements_1.DivEl()
            .setClass('fs-6')
            .setId('objectInfoControls')
            .addChild(this.objectUuidRow)
            .addChild(this.objectTypeRow)
            .addChild(this.objectNameRow)
            .addChild(this.xyzLabelRow)
            .addChild(this.objectPositionRow)
            .addChild(this.objectRotationRow)
            .addChild(this.objectScaleRow)
            .addChild(this.objectIntensityRow)
            .addChild(this.objectColorRow)
            .addChild(this.objectDistanceRow)
            .addChild(this.objectAngleRow)
            .addChild(this.objectPenumbraRow)
            .addChild(this.objectDecayRow);
    }
    createSingleRow(uiElement) {
        return new UiElements_1.RowEl().addClass('me-0').addClass('mt-1')
            .addChild(new UiElements_1.ColEl().setClass('col-12').addChild(uiElement));
    }
    createKeyValRow(uiElement, label) {
        return new UiElements_1.RowEl().addClass('me-0').addClass('mt-1')
            .addChild(new UiElements_1.ColEl().setClass('col-4').addChild(new UiElements_1.LabelEl("").addAttribute('data-i18n-key', label)))
            .addChild(new UiElements_1.ColEl().setClass('col-8 p-0').addChild(uiElement));
    }
    createXYZLabelRow() {
        return new UiElements_1.RowEl()
            .addClass('me-0')
            .addClass('mt-1')
            .addChild(new UiElements_1.ColEl().setClass('col-4'))
            .addChild(new UiElements_1.ColEl()
            .setClass('col-8 p-0 d-inline-flex')
            .addChild(new UiElements_1.LabelEl('x').setStyle({ 'width': '50px' }).addClass('text-center'))
            .addChild(new UiElements_1.LabelEl('y').setStyle({ 'width': '50px' }).addClass('text-center'))
            .addChild(new UiElements_1.LabelEl('z').setStyle({ 'width': '50px' }).addClass('text-center')));
    }
    createXYZRow(xInput, yInput, zInput, label) {
        return new UiElements_1.RowEl().addClass('me-0').addClass('mt-1')
            .addChild(new UiElements_1.ColEl().setClass('col-4').addChild(new UiElements_1.LabelEl("").addAttribute('data-i18n-key', label)))
            .addChild(new UiElements_1.ColEl().setClass('col-8 p-0 d-inline-flex').addChild(xInput).addChild(yInput).addChild(zInput));
    }
    createInputDiv() {
        return new UiElements_1.InputEl("")
            .setClass('form-control form-control-sm p-1 me-1')
            .setStyle({ 'width': '50px' });
    }
    createColorDiv() {
        return new UiElements_1.ColorEl();
    }
    createTextDiv(text = "") {
        return new UiElements_1.TextEl(text);
    }
}
exports.ObjectInfoControls = ObjectInfoControls;
class ObjectInfoControls2 {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (objectInfo) is undefined");
        }
        this.tableEl = this.createElement();
        parentEl.appendChild(this.tableEl);
    }
    dispose() {
        delete this.element;
    }
    visible(visible) {
        var _a;
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.setDisplay(visible ? '' : 'none');
    }
    createElement() {
        const tableEl = document.createElement('table');
        tableEl.classList.add('transformation-table');
        // x, y, z labels row
        const titleRow = document.createElement('tr');
        const emptyCell = document.createElement('th');
        emptyCell.innerHTML = '&nbsp;';
        const xCell = document.createElement('th');
        xCell.setAttribute('scope', 'col');
        xCell.innerText = 'x';
        const yCell = document.createElement('th');
        yCell.setAttribute('scope', 'col');
        yCell.innerText = 'y';
        const zCell = document.createElement('th');
        zCell.setAttribute('scope', 'col');
        zCell.innerText = 'z';
        titleRow.append(emptyCell, xCell, yCell, zCell);
        // Position row
        const positionRow = document.createElement('tr');
        const positionLabelCell = document.createElement('th');
        positionLabelCell.setAttribute('scope', 'row');
        positionLabelCell.setAttribute('data-i18n-key', 'POSITION');
        const positionXCell = document.createElement('td');
        this.positionXInput = document.createElement('input');
        this.positionXInput.name = 'positionX';
        this.positionXInput.type = 'text';
        positionXCell.appendChild(this.positionXInput);
        const positionYCell = document.createElement('td');
        this.positionYInput = document.createElement('input');
        this.positionYInput.name = 'positionY';
        this.positionYInput.type = 'text';
        positionYCell.appendChild(this.positionYInput);
        const positionZCell = document.createElement('td');
        this.positionZInput = document.createElement('input');
        this.positionZInput.name = 'positionZ';
        this.positionZInput.type = 'text';
        positionZCell.appendChild(this.positionZInput);
        positionRow.append(positionLabelCell, positionXCell, positionYCell, positionZCell);
        // Rotation row
        const rotationRow = document.createElement('tr');
        const rotationLabelCell = document.createElement('th');
        rotationLabelCell.setAttribute('scope', 'row');
        rotationLabelCell.setAttribute('data-i18n-key', 'ROTATION');
        const rotationXCell = document.createElement('td');
        this.rotationXInput = document.createElement('input');
        this.rotationXInput.name = 'rotationX';
        this.rotationXInput.type = 'text';
        rotationXCell.appendChild(this.rotationXInput);
        const rotationYCell = document.createElement('td');
        this.rotationYInput = document.createElement('input');
        this.rotationYInput.name = 'rotationY';
        this.rotationYInput.type = 'text';
        rotationYCell.appendChild(this.rotationYInput);
        const rotationZCell = document.createElement('td');
        this.rotationZInput = document.createElement('input');
        this.rotationZInput.name = 'rotationZ';
        this.rotationZInput.type = 'text';
        rotationZCell.appendChild(this.rotationZInput);
        rotationRow.append(rotationLabelCell, rotationXCell, rotationYCell, rotationZCell);
        // Scale row
        const scaleRow = document.createElement('tr');
        const scaleLabelCell = document.createElement('th');
        scaleLabelCell.setAttribute('scope', 'row');
        scaleLabelCell.setAttribute('data-i18n-key', 'SCALE');
        const scaleXCell = document.createElement('td');
        this.scaleXInput = document.createElement('input');
        this.scaleXInput.name = 'scaleX';
        this.scaleXInput.type = 'text';
        scaleXCell.appendChild(this.scaleXInput);
        const scaleYCell = document.createElement('td');
        this.scaleYInput = document.createElement('input');
        this.scaleYInput.name = 'scaleY';
        this.scaleYInput.type = 'text';
        scaleYCell.appendChild(this.scaleYInput);
        const scaleZCell = document.createElement('td');
        this.scaleZInput = document.createElement('input');
        this.scaleZInput.name = 'scaleZ';
        this.scaleZInput.type = 'text';
        scaleZCell.appendChild(this.scaleZInput);
        scaleRow.append(scaleLabelCell, scaleXCell, scaleYCell, scaleZCell);
        tableEl.append(titleRow, positionRow, rotationRow, scaleRow);
        return tableEl;
    }
}
exports.ObjectInfoControls2 = ObjectInfoControls2;
